export default __webpack_public_path__ + "static/media/TuyaAirQuality.8f110705.png";